import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CONSTANTS } from '@app/constants';
import { CanonicalService } from '@app/data';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  private init: boolean = false;

  constructor(
    private title: Title,
    private meta: Meta,
    private canonical: CanonicalService
  ) {}

  public setMetaTags = (page: any): void => {
    console.log('MetaService setMeta page', page);

    const imageRelativeUrl = page.field_image_url.replace(CONSTANTS.baseUrl, '');
    const title = page.title === '' ? 'My na to máme' : page.title + ' | My na to máme';
    let description = page.summary ? page.summary : 'portál moderního vzdělávání';
    const type = page.content_type ? page.content_type : 'website';
    const queryParams = page.path_page ?  new URLSearchParams({sekce: page.path_page[0]}).toString() : false;
    const url = /*page.path_page ? CONSTANTS.url + page.path_page + page.url :*/ queryParams ? CONSTANTS.url + page.url + '?' + queryParams : CONSTANTS.url + page.url;
    let image = CONSTANTS.baseUrl + imageRelativeUrl;
    const videoProvider = page.field_video_platform === '9' ? 'youtube' : page.field_video_platform === '10' ? 'vimeo' : false;

    description = description.split('<p>').join('');
    description = description.split('</p>').join('');
    description = description.split('<br />').join('');

    image = image.replace(CONSTANTS.imageMetaStyle[0], CONSTANTS.imageMetaStyle[1]);

    //console.log('MetaService setMeta image', image);
    console.log('MetaService setMeta url', url);

    this.title.setTitle(title);

    //this.canonical.createCanonicalLink(url);

    this.updateTags([

      { name: 'title', content: title },
      { name: 'description', content: description },

      { property: 'og:type', content: type },
      { property: 'og:url', content: url },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:image:secure_url', content: image },
      { property: 'og:image:alt', content: title },

      { name: 'twitter:card', content: 'summary_large_image' }/*,
      { name: 'twitter:url', content: url },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image }*/

    ]);

    if (videoProvider && page.field_video_id) {
      const video = videoProvider === 'youtube' ? 'https://www.youtube.com/v/' + page.field_video_id : 'https://vimeo.com/' + page.field_video_id;

      this.updateTags([

        { property: 'og:video', content: video },
        { property: 'og:video:url', content: video },
        { property: 'og:secure_url', content: video },
        { property: 'og:video:type', content: 'video/mp4' },
        { property: 'og:video:width', content: '1600' },
        { property: 'og:video:height', content: '900' }/*,
        { name: 'twitter:card', content: 'player' },
*/
      ]);
    }
    else {

      this.meta.removeTag("property='og:video'");
      this.meta.removeTag("property='og:video:url'");
      this.meta.removeTag("property='og:video:secure_url'");
      this.meta.removeTag("property='og:video:type'");
      this.meta.removeTag("property='og:width'");
      this.meta.removeTag("property='og:height'");
      //this.meta.removeTag("name='twitter:video'");

    }
  }

  private updateTags = (tags: any[]): void => {

    for (var i = 0; i < tags.length; ++i) {
      if (!this.init) {
        this.meta.addTag(tags[i]);
      }
      else {
        this.meta.updateTag(tags[i]);
      }
    }

    this.init = true;
  }   
}
